import { productTypeOptions, warehouseManagerOrderStatusOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import OrderNumberCell from "components/table/columnComponents/OrderNumberCell"
import OrdersQuantity from "components/table/columnComponents/OrdersQuantity"
import RowExpandToggle from "components/table/columnComponents/RowExpandToggle"
import { StatusOfWHOrder } from "components/table/columnComponents/StatusOfWHOrder"

export const warehouseOrderTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "",
    size: "mini",
    name: "group_toggle",
    cellComponent: RowExpandToggle,
  },
  {
    title: "Order number",
    type: "search",
    name: "item_id",
    size: "middle",
    cellComponent: OrderNumberCell,
  },
  {
    title: "Status",
    type: "select",
    size: "middle",
    name: "item_status",
    options: warehouseManagerOrderStatusOptions,
    cellComponent: StatusOfWHOrder,
  },
  {
    title: "Device",
    type: "select",
    name: "product_type",
    size: "small",
    options: productTypeOptions,
  },
  {
    title: "Quantity",
    type: "search",
    name: "quantity",
    size: "small",
    cellComponent: OrdersQuantity,
    cellComponentProps: {
      isWHManager: true,
    },
  },
  {
    title: "Company name",
    type: "sort-search",
    name: "company_name",
  },
  {
    title: "Brand name",
    type: "sort-search",
    name: "brand_name",
  },
  {
    title: "Contractor ID",
    type: "sort-search",
    size: "middle",
    name: "contractor_id",
  },
]
